import React from "react";

interface TelcoListingHeroProps {
  settings: {
    settings: {
      section: {
        button_text?: string;
        description?: string;
        footer?: string;
        heading?: string;
        placeholder_input_email?: string;
      };
    };
  };
}

export const TelcoListingHero: React.FC<TelcoListingHeroProps> = ({ settings }) => {
  // Extract all data from settings
  const { container_type, button_text, description, footer, heading, placeholder_input_email, use_form } =
    settings.settings.section;

  return (
    <section className={`telco-listing-hero flex flex-col ${container_type} max-w-[768px] mx-auto text-center`}>
      <div className="flex flex-col gap-5">
        <h2 className="h2">
          {heading}
        </h2>
         {description && (
          <div className="b_small_normal" dangerouslySetInnerHTML={{ __html: String(description) }} />
        )}
      </div>
      <div className="flex flex-col flex-wrap flex-1 gap-4 pt-2 lg:pt-6">
        {use_form ?
          <div className="hs-form-frame" data-region="ap1" data-form-id={settings.settings.section.section_hubspot_form_id} data-portal-id="24047364"></div>
        :
          <form
            action=""
            className="flex gap-4 flex-col lg:flex-row pt-4"
          >
            <div className="p-[2px] rounded-[5px] bg-[linear-gradient(270deg,_#917DF1_0%,_#D6CFF8_25%,_#F1E8DE_50%,_#899B30_75%,_#3A4B24_100%)] flex-1">
              <div className="bg-white rounded-[3px]">
                <input
                  className="h-[48px] px-4 py-3 rounded-[5px] outline-none w-full text-[18px] text-[#2E2C29] placeholder:text-[#2E2C29] font-[poppins,sans-serif] opacity-50 font-light"
                  style={{ paddingBottom: "12px", fontSize: "18px" }}
                  type="email"
                  placeholder={placeholder_input_email}
                  required
                />
              </div>
            </div>
            <button
              className="button button-primary"
              type="submit"
            >
              {button_text}
            </button>
          </form>
        }
        <div className="flex justify-center flex-1">
          {footer && (
            <div className="b_tiny_normal" dangerouslySetInnerHTML={{ __html: String(footer) }} />
          )}
        </div>
      </div>
    </section>
  );
};

export default TelcoListingHero;
